import bindOnce from './bindOnce'

export default function setMaskedUrls () {
  const uncrawlableLinkElements = Array.from(document.getElementsByClassName('vjs-masked-url'))
  uncrawlableLinkElements.forEach(element => bindOnce(element, 'click', 'MaskedUrl', event => {
    window.location.href = event.currentTarget.getAttribute('data-masked-url')
  }))
}
